import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LandingPage from './LandingPage';
import ProtectedRoute from './ProtectedRoute';
import AuthCallback from './AuthCallback';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const AuthHandler = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  let content = null;

  if (isLoading) {
    content = (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <div className="mt-3">Loading...</div>
        </div>
      </div>
    );
  } else if (isAuthenticated) {
    content = <ProtectedRoute />;
  } else {
    content = <LandingPage />;
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div
        id="kg-build-marker"
        data-build="toast-root-20260115-0001"
        style={{ position: 'fixed', bottom: 4, right: 6, zIndex: 999999, fontSize: 10, opacity: 0.2 }}
      >
        toast-root-20260115-0001
      </div>
      {content}
    </>
  );
};

export default AuthHandler;
